import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    linkId = '',
    password = '',
    search = '',
    pi = 1,
    ps = 20,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utableShare.getShareTableData, {
        linkId,
        password,
        search,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || {};
};
